<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Comedy
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Comedy</strong> recorded $129.9m in revenue and close to 2.2m attendances.</p>
          <p>Top events included the Melbourne International Comedy Festival and performances by Sooshi Mango and renowned international comedians such as Kevin Hart, Jimmy O. Yang, Paul Smith, Graham Norton, Urzila Carlson and Sarah Millican.</p>
          <p><strong>Comedy</strong> recorded a y-o-y decline in revenue of 24.0% (from $170.9m in 2024 to $129.9m in 2025) and a y-o-y decline in attendance of 10.2% (from 2.4m in 2024 to 2.2m in 2025).</p>
          <p>The average ticket price declined by 15.3% (from $74.17 in 2024 to $62.82 in 2025), which further contributed to the decline in revenue.</p>
          <p><strong>Comedy</strong> generated 3.9% of the overall live performance revenue and 7.1% of the overall live performance attendance in 2025.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, VIC and NSW generated the most revenue and attendance in this category. These two states together generated 67.0% of overall revenue and 71.3% of overall attendance in this category.</p>
          <p>Top events in VIC and NSW included Melbourne International Comedy Festival and performances by Sooshi Mango and renowned international comedians such as Kevin Hart, Jimmy O. Yang, Paul Smith, Graham Norton, Jo Koy, Jack &amp; Michael Whitehall, Russell Peters and Sarah Millican.</p>
          <p>In 2025, all states and territories recorded a y-o-y decline in revenue, while all states and territories except NT recorded a y-o-y decline in attendance.</p>
          <p>The overall decline in this category was primarily driven by declines across the major markets, particularly VIC, NSW and QLD. VIC recorded a y-o-y decline of 18.9% in revenue and 5.9% in attendance, NSW recorded a y-o-y decline of 24.3% in revenue and 13.0% in attendance, and QLD recorded a y-o-y decline of 26.3% in revenue and 16.6% in attendance.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/COMEDY  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Comedy Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Great Laugh in the Park - Trash Test Dummies</em>, Sydney Comedy Festival, Photo Credit: Nick Robertson</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [39.57, 39.048, 52, 48.695, 41.473, 45.155, 54.924, 86.383, 72.306, 124.742, 103.216, 21.49, 50.301, 114.965, 198.785, 170.863, 129.905],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.769, 0.793, 1.011, 0.981, 0.913, 0.963, 0.992, 1.409, 1.238, 2.458, 2.172, 0.338, 1.172, 2.133, 2.88, 2.437, 2.187],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 24.6],
            ["VIC", 42.4],
            ["QLD", 15.8],
            ["WA", 9.4],
            ["SA", 3.6],
            ["ACT", 2.8],
            ["TAS", 0.9],
            ["NT", 0.4],
          ],
          attendance: [
            ["NSW", 17.3],
            ["VIC", 54.0],
            ["QLD", 15.4],
            ["WA", 6.8],
            ["SA", 2.8],
            ["ACT", 2.4],
            ["TAS", 0.9],
            ["NT", 0.4],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/22-Comedy-Sydney-Comedy-Festival---Great-Laugh-in-The-Park---Image-by-Nick-Robertson---26_4_2025-(1).jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
